__turbopack_context__.v({
  "fit_layout": "fit_layout-module__YXVM_q__fit_layout",
  "fit_layout__content": "fit_layout-module__YXVM_q__fit_layout__content",
  "fit_layout_loading": "fit_layout-module__YXVM_q__fit_layout_loading",
  "fit_layout_title": "fit_layout-module__YXVM_q__fit_layout_title",
});
